<template>
  <div class>
    <button :type="type" :class="classes" @click="$emit('click')" :disabled="disabled">
      <span v-if="icon && iconPosition === 'right'" class="button-text">
        <slot />
      </span>

      <span v-if="!icon" class="button-text">
        <slot />
      </span>

      <span class="icon is-small" v-if="icon">
        <fa-icon :icon="icon" />
      </span>

      <span v-if="icon && iconPosition === 'left'" class="button-text">
        <slot />
      </span>
    </button>
  </div>
</template>

<script>
import { validateModifier } from '@/utilities'

export default {
  name: "custom-button",
  props: {
    modifier: {
      type: String,
      default: "secondary",
      validator(value) {
        return validateModifier(value);
      }
    },
    type: {
      type: String,
      default: "button",
      validator(value) {
        return ["button", "menu", "reset", "submit"].includes(value);
      }
    },
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].includes(value);
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    static: {
      type: Boolean,
      default: false
    },
    icon: Object,
    iconPosition: {
      type: String,
      default: "right",
      validator(value) {
        return ["left", "right"].includes(value);
      }
    },
    disabled: Boolean
  },
  computed: {
    classes() {
      var classes = {
        "button": true,
        "is-loading": this.isLoading,
        "is-small": this.size === "small",
        "is-medium": this.size === "large",
        "is-static": this.static
      }

      if (validateModifier(this.modifier))
        classes["is-" + this.modifier] = true;

      return classes;
    }
  }
}
</script>

<style lang="sass" scoped>
.control
  text-align: match-parent

.button-text
  margin-top: -3px
</style>